import script from "./ContactView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactView.vue?vue&type=script&lang=ts&setup=true"

import "./ContactView.vue?vue&type=style&index=0&id=357ec68a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357ec68a"]])

export default __exports__